import { idCardNoParse } from './util'

export const MOBILE_REG = /^1\d{10}$/
export const SMS_CODE_REG = /\d{4}/
export const ID_CARD_REG = /^([1-9]\d{5})(\d{4})(\d{2})(\d{2})(\d{3}(\d|X|x))$/
export const CERT_SERIES_NO_REG = /^\d{8}(\d|[A-Z]){8}$/

export const mobileValidator = (rule, value, cb) => {
  if (MOBILE_REG.test(value)) {
    cb()
  } else {
    cb(new Error('手机号格式不正确'))
  }
}

export const smsCodeValidator = (rule, value, cb) => {
  if (SMS_CODE_REG.test(value)) {
    cb()
  } else {
    cb(new Error('验证码输入错误'))
  }
}

export const idCardValidator = (rule, value, cb) => {
  if (!ID_CARD_REG.test(value) || !idCardNoParse(value)) {
    cb(new Error('身份证号码输入错误'))
  } else {
    cb()
  }
}
